import {
    useShopperBasketsMutationHelper,
    useShopperBasketsMutation,
    useAccessToken,
    useCommerceApi,
} from '@salesforce/commerce-sdk-react'
import {useCallback} from 'react'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'

export const useCartActions = () => {
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const applyPromoCodeMutation = useShopperBasketsMutation('addCouponToBasket')
    const {data: basket} = useCurrentBasket()
    const {getTokenWhenReady} = useAccessToken()
    const api = useCommerceApi()

    //First, Fetch product details from API
    const handleItemSearch = useCallback(async (code) => {
        try {
            const token = await getTokenWhenReady()
            const _retrievedProducts = await api.shopperProducts.getProducts({
                parameters: {ids: code, allImages: true},
                headers: {Authorization: `Bearer ${token}`},
            })
            return _retrievedProducts
        } catch (error) {
            console.error('Error fetching product details:', error)
            return null
        }
    }, [])

    //Then, Add items to the cart
    const addToCart = async (code, qty) => {
        try {
            const productData = await handleItemSearch(code)
            if (!productData || !productData.data || productData.data.length === 0) {
                console.error('Product not found:', code)
                return
            }

            const productItems = productData.data.map((product) => ({
                productId: product.id,
                price: product.price,
                quantity: qty,
            }))
            await addItemToNewOrExistingBasket(productItems)
            return productItems
        } catch (error) {
            console.error('Error adding to cart:', error)
        }
    }

    const applyCoupon = async (code) => {
        try {
            await applyPromoCodeMutation.mutateAsync({
                parameters: {basketId: basket?.basketId},
                body: {
                    code,
                },
            })
        } catch (e) {
            console.error(`Error applying promo code ${code} with error : ${e.message}`)
        }
    }

    return {addToCart, applyCoupon}
}
